/**
 * Colour tokens for the Returns Inbox conversation pieces (out-of-band log, captured
 * replies, reply box). OPAQUE hex pairs applied as inline styles — the Hub is a LIGHT theme
 * and Tailwind alpha utilities composite to pale-on-pale there (see cadenceBadges.js for
 * the measured 1.11:1 that taught us this). Every pair is asserted >= 4.5:1 in
 * returnsLoopTokens.contrast.test.js.
 */
export const SURFACE = '#FFFFFF';

export const TONE = {
  // text + its own opaque chip/panel background
  neutral: { fg: '#1A1A1A', bg: '#FFFFFF', border: '#E2E2DC' },
  dim:     { fg: '#57534E', bg: '#FFFFFF', border: '#E2E2DC' },
  ok:      { fg: '#166534', bg: '#F0FDF4', border: '#16A34A' },
  warn:    { fg: '#92400E', bg: '#FFFBEB', border: '#D97706' },
  error:   { fg: '#991B1B', bg: '#FEF2F2', border: '#DC2626' },
  // "happened outside the Hub" — deliberately not green: recorded, not sent by us
  outside: { fg: '#1E3A8A', bg: '#EFF6FF', border: '#2563EB' },
};

export const toneStyle = (name) => {
  const t = TONE[name] || TONE.neutral;
  return { color: t.fg, backgroundColor: t.bg, borderColor: t.border };
};

export const CHANNEL_LABEL = {
  phone: 'Phone call',
  email_direct: 'Email (sent outside the Hub)',
  outlook_direct: 'Email from Outlook',
  text: 'Text message',
  in_person: 'In person',
};
